import React, { useEffect } from 'react';
import './MainLayout.css'
import Header from "../../components/Header/Header";
import FooterContainer from "../../components/Footer/FooterContainer/FooterContainer";
import { HeaderProvider } from '../../context/Header/HeaderContext';
import WhatsAppFAB from '../../components/WhatsAppFAB/WhatsAppFAB';
import backgroundImage from '../../assets/fondo-web-forvet.svg'
import PulseFABButton from "../../components/PulseFABButton/PulseFABButton";
import { useLocation } from 'react-router-dom';
import GrandNavbar from '../../features/GrandPage/GrandNavbar/GrandNavbar';
function MainLayout({
   children,
   overflow = 'visible',
   bg = null,
   header
}) {

   const { pathname } = useLocation()
   const IS_GRAND = pathname.startsWith("/grand/")

   useEffect(() => {
      const body = document.querySelector('body')
      if (body) {
         IS_GRAND ?  body.style.backgroundImage = "none"
         : body.style.backgroundImage = `url(${backgroundImage})`
      }
   }, [IS_GRAND])

   return (
      <div className="mainLayout__container"
         style={{
            overflow,
            background: bg ?? '',
         }}
      >
         {header ?? <HeaderProvider>
            {IS_GRAND ? <GrandNavbar dark /> : <Header />}
         </HeaderProvider>}
         <main>
            {children}
            <WhatsAppFAB />
            {!IS_GRAND && <PulseFABButton />}
         </main>
         <FooterContainer isGrand={IS_GRAND} />
      </div>
   );
}

export default MainLayout;